import type { PersonPropsStore } from '@flashka/shared/analytics/person-props-once';

/**
 * Where web remembers which PostHog person properties it already sent (see
 * `personPropsChanged`). localStorage survives reloads, so a page load with
 * unchanged values sends no `$set`; a private window or blocked storage just
 * throws, and the caller sends as before.
 */
export const personPropsStore: PersonPropsStore = {
  get: (key) => window.localStorage.getItem(key),
  set: (key, value) => window.localStorage.setItem(key, value),
};
